export function fmtRM(n) {
  const num = Number(n || 0);
  return `RM ${num.toLocaleString("en-MY", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

export function fmtRMSigned(n) {
  const num = Number(n || 0);
  const sign = num < 0 ? "-" : "";
  return `${sign}RM ${Math.abs(num).toLocaleString("en-MY", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

export function fmtMonth(ym) {
  if (!ym || ym === "Unknown") return "Unknown";
  const [y, m] = ym.split("-");
  const names = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return `${names[parseInt(m, 10) - 1]} ${y}`;
}

// Client-side mirror of the backend repayment formula parser (for live preview)
export function parseFormula(raw) {
  raw = (raw || "").trim();
  const result = {
    type: "unknown",
    monthlyInterest: 0,
    monthlyPrincipal: 0,
    durationMonths: null,
    settlementAmount: 0,
    rawFormula: raw,
    valid: false,
  };
  if (!raw) return result;

  let m = raw.match(/^(\d+(?:\.\d+)?)\s*\+\s*(\d+(?:\.\d+)?)\s*\(\s*(\d+)\s*M\s*\)$/i);
  if (m) {
    return { ...result, type: "installment", monthlyInterest: +m[1], monthlyPrincipal: +m[2], durationMonths: +m[3], valid: true };
  }
  m = raw.match(/^i\s*=\s*(\d+(?:\.\d+)?)$/i);
  if (m) {
    return { ...result, type: "interest_only", monthlyInterest: +m[1], valid: true };
  }
  m = raw.match(/^(\d+(?:\.\d+)?)\s*[x*]\s*(\d+)\s*M$/i);
  if (m) {
    return { ...result, type: "settlement", settlementAmount: +m[1], durationMonths: +m[2], valid: true };
  }
  return result;
}

export function formulaLabel(type) {
  switch (type) {
    case "installment": return "Installment";
    case "interest_only": return "Interest-Only";
    case "settlement": return "One-Time Settlement";
    default: return "Unrecognized";
  }
}
